import axios from "axios"
import { sortOrders, COMMENTS_LIMIT } from "@/constants/comments.js"

export const credentials = () => axios.post("/api/v1/federated_credentials")

export const prevComments = ({ id, cursor }) =>
  axios.get(`/api/v1/files/${id}/comments`, {
    params: {
      after_timestamp: cursor,
      sort_order: sortOrders.DESCENDING,
      limit: COMMENTS_LIMIT
    }
  })

export const nextComments = ({ id, cursor }) =>
  axios.get(`/api/v1/files/${id}/comments`, {
    params: {
      after_timestamp: cursor,
      sort_order: sortOrders.ASCENDING,
      limit: COMMENTS_LIMIT
    }
  })

export const addComment = (id, comment) => {
  return axios.post(`/api/v1/files/${id}/comments`, comment)
}

export const like = (id) => axios.post(`/api/v1/files/${id}/like`)

export const unlike = (id) => axios.delete(`/api/v1/files/${id}/like`)

export const likingUsers = ({ id, page }) =>
  axios.get(`/api/v2/files/${id}/liking_users`, {
    params: {
      page
    }
  })

export const getArticles = ({ query, page, signal } = {}) =>
  axios.get("/api/v2/files", {
    signal,
    params: {
      page,
      query
    }
  })

export const getVideoIframeUrl = (id) => axios.get(`/api/v3/videos/${id}/iframe_url`)

export const registerVideoPlay = (id) => axios.post(`/api/v3/videos/${id}/track_play`)
